/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_Ready_For_SubmissionInputs */

const en_error_inbound_not_ready_for_submission = /** @type {(inputs: Error_Inbound_Not_Ready_For_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The inbound cannot be sent yet. What it still needs is listed next to its header: the invoice, the packing list and their documents.`)
};

/**
* | output |
* | --- |
* | "The inbound cannot be sent yet. What it still needs is listed next to its header: the invoice, the packing list and their documents." |
*
* @param {Error_Inbound_Not_Ready_For_SubmissionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_ready_for_submission = /** @type {((inputs?: Error_Inbound_Not_Ready_For_SubmissionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_Ready_For_SubmissionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_ready_for_submission(inputs)
});